<start-order *ngIf="applicationService.isShowPopup()"
             (saved)="applicationService.onStartOrderPopupSaveCallback()"
             (closed)="applicationService.onStartOrderPopupCloseCallback()">
</start-order>
